<template>
  <b-list-group-item href="javascript:void(0);" @click="$emit('click')">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span style="flex:1;">{{ item.title }}</span>
      <!--<b-btn
        @click.stop
        v-if="item.recipe.length > 0"
        size="sm"
        variant="light"
        class="border px-1 py-0"
        v-b-toggle="'collapse-' + item.id"
        ><b-icon-chevron-down
      /></b-btn>-->
      <b-btn
        @click.stop="$emit('edit')"
        v-if="showEdit"
        size="sm"
        variant="light"
        class="border px-1 py-0 ml-2"
        ><b-icon-pencil
      /></b-btn>
      <b-btn
        @click.stop="details(item)"
        v-if="showDetails"
        size="sm"
        variant="light"
        class="border px-1 py-0 ml-2"
        ><b-icon-info-circle class="text-primary"
      /></b-btn>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <b-badge v-for="tag in item.tags" :key="tag" class="recipeTag mr-1">{{
          tag
        }}</b-badge>
        <div v-if="item.tags.length === 0">&nbsp;</div>
      </div>
      <div>
        <b-badge
          v-for="oneType in item.type"
          :key="oneType"
          class="recipeType ml-1"
          :variant="getItemVariantColor(oneType)"
          >{{ oneType }}</b-badge
        >
      </div>
    </div>
    <!--<b-collapse :id="'collapse-' + item.id" v-if="item.recipe.length > 0">
      <div class="font-weight-light mt-2">
        <b-row
          v-for="(ingredient, i) in item.recipe"
          :key="'ing-' + item.id + '-' + i"
        >
          <b-col cols="3">{{ ingredient.amount }}{{ ingredient.unit }}</b-col>
          <b-col cols="9">{{ ingredient.title }}</b-col>
        </b-row>
      </div>
    </b-collapse>-->
  </b-list-group-item>
</template>

<script>
import { mapGetters } from "vuex";
import { getRecipe } from "../class/recipe";
export default {
  name: "Recipe",
  props: {
    item: Object,
    showEdit: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getItemVariantColor"])
  },
  methods: {
    details(item) {
      getRecipe(item.id).then(recipe => {
        this.$store.commit("SET_DETAILITEM", recipe);
        this.$root.$emit("bv::toggle::collapse", "sidebar-right");
      });
    }
  }
};
</script>

<style></style>
